export class OrganizationPermissions {
    public static readonly AccountOwner = "account.owner";
    public static readonly ViewAppointments = "myaccount.viewappointments";
    public static readonly ViewOrders = "myaccount.vieworders";
    public static readonly ViewSupportCases = "myaccount.viewsupportcases";
    public static readonly ManageAccess = "organization.manageaccess";
    public static readonly ManageProducts = "organization.manageproducts";
    public static readonly UpdateProducts = "organization.updateproducts";
    public static readonly ViewProducts = "organization.viewproducts";
    public static readonly PurchaseOnAccount = "webshop.purchaseonbehalfoforganization";
}
